// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"191":"8e5647ce","722":"fc2e075b","881":"94c9f700"}[chunkId] + ".chunk.css";
};